import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {Form, Modal} from 'antd';
import {paymentPosStore} from "../PaymentPosStore";
import {useNavigate, useParams} from "react-router-dom";
import SelectCustom from "../../../../shared/components/form/SelectCustom";
import {productInPostStore} from "../../productInPos/ProductInPostStore";
const ModalSmartPos = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    useEffect(() => {
        form.setFieldsValue({
            machine_pos_id: paymentPosStore.staticParamPaymenSmartPos.machine_pos_id,
        });
    }, [form,paymentPosStore.staticParamPaymenSmartPos.machine_pos_id]);
    return (
        <>
            <Modal className="modal-form modal-smart-pos" title="Thanh toán Smart POS" closable={false} onCancel={() => {
                paymentPosStore.isModalSmartPos = false;
                paymentPosStore.staticParamPaymenSmartPos.machine_pos_id  = undefined
            }} open={paymentPosStore.isModalSmartPos} footer={null}>
                <Form
                    form={form}
                    name="room-form"
                    onFinish={(values) => {
                        paymentPosStore.fetchCreateNewPaymentPos()
                    }}
                >
                    <>
                        <div className="form-modal-image">
                            <Form.Item
                                className="item-form"
                                name="machine_pos_id"
                                label={'Smart POS'}
                                rules={[
                                    {
                                        required: true,
                                        message: "Vui lòng chọn trường này",
                                    },
                                ]}
                            >
                                <SelectCustom
                                    list={
                                        Array.isArray(productInPostStore?.dataPosMachine?.smart_pos)
                                            ? productInPostStore.dataPosMachine.smart_pos.filter((item: any) => item.status === 1)
                                            : []
                                    }
                                    placeholder="Vui lòng chọn"
                                    showSearch
                                    onChange={(value: any) => {
                                        paymentPosStore.staticParamPaymenSmartPos.machine_pos_id = value;
                                    }}
                                    selected={() => paymentPosStore.staticParamPaymenSmartPos.machine_pos_id}
                                    getLabel={(item: any) => item.pos_name}
                                />
                            </Form.Item>
                        </div>
                        <div className={'create-qr-swipe-the-card'}>
                            <button type="submit" className={'create-qr'} onClick={() => {
                                paymentPosStore.staticParamPaymenSmartPos.payment_type = 'QR'
                            }}>
                                <img src="/assets/icon/create-qr.svg" alt="Tạo QR"/>
                                <p>Tạo QR</p>
                            </button>
                            <button type="submit" className={'swipe-the-card'} onClick={() => {
                                paymentPosStore.staticParamPaymenSmartPos.payment_type = 'CARD'

                            }}>
                                <img src="/assets/icon/swipe-the-card.svg" alt="Quẹt thẻ"/>
                                <p>Quẹt thẻ</p>
                            </button>
                        </div>
                        {/*<div className="footer-note">*/}
                        {/*    <Button className="btnCloseNote" onClick={() => paymentPosStore.handleCancelImageQr()}>*/}
                        {/*        Hủy bỏ*/}
                        {/*    </Button>*/}
                        {/*    <Button type="primary" htmlType="submit" className="btnAddNotePay" disabled={paymentPosStore.isSave}>*/}
                        {/*        {paymentPosStore.isSave ? "Vui lòng đợi..." :  "Xác nhận"}*/}
                        {/*    </Button>*/}
                        {/*</div>*/}
                    </>
                </Form>
            </Modal>
        </>
    )
}
export default observer(ModalSmartPos)